import React from "react";
import {Icon, Modal, Upload} from "antd";
import BaseComponent from "../../redare/components/BaseComponent";
import {getResource, uploadImgType} from "../../common/ConstField";

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export default class UploadImg extends BaseComponent {

    state = {
        previewImage: '',
    };

    handleChange = (info) => {
        let file = info.file;
        if (file.status === 'uploading') {
            return;
        }
        if (file.status === 'done') {
            let {response} = file;
            if (response && response.code === 1) {
                this.toastFail(response.message);
            }
            this.previewImage = response.data.url;
            this.setState({previewImage:response.data.url})
            getBase64(file.originFileObj, imageUrl =>
                this.setState({
                    imageUrl,
                }),
            );
        }
    };

    constructor(props) {
        super(props);
    }

    //设置图片显示
    _setPreviewImg(url){
        this.setState({previewImage:url});
    }

    render() {
        const {previewImage} = this.state;
        const uploadButton = (
            <div>
                <Icon type="plus" />
                <div className="ant-upload-text">上传</div>
            </div>
        );
        return (
            <div className="clearfix UploadImg">
                <Upload
                    name="file"
                    action={`${getResource().IMAGE}`}
                    listType="picture-card"
                    showUploadList={false}
                    onChange={this.handleChange}
                    accept={uploadImgType}
                >
                    <div className="up-img">
                        {previewImage ? <img alt="example" src={previewImage} style={{width: '100%'}}/> : uploadButton}
                    </div>
                </Upload>
            </div>
        )
    }
}
